import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import { FieldReferenceTypeEnum } from 'src/app/components/utility/field-reference-type/field-reference-type-enum';

import { DirectoryEditRestrictionsEntryRemoteDto } from 'src/generated/signalR/directory-edit-restrictions-entry-remote-dto';
import { DirectoryEditRestrictionsUpdated } from './directory-edit-restrictions.actions';

export interface DirectoryEditRestrictionsStateModel {
   directoryEditRestrictions: DirectoryEditRestrictionsEntryRemoteDto[];
}
@State<DirectoryEditRestrictionsStateModel>({
   name: 'directoryEditRestrictions',
   defaults: {
      directoryEditRestrictions: [],
   },
})
@Injectable()
export class DirectoryEditRestrictionsState {
   public static readonly ORGLEVEL_SUBSCRIBER = 0;

   @Selector([DirectoryEditRestrictionsState])
   public static getDirectoryEditRestrictions(state: DirectoryEditRestrictionsStateModel): DirectoryEditRestrictionsEntryRemoteDto[] {
      return state.directoryEditRestrictions;
   }

   @Selector([DirectoryEditRestrictionsState.getDirectoryEditRestrictions])
   public static getDirectoryEditRestrictionsByGroupIds(directoryEditRestrictions: DirectoryEditRestrictionsEntryRemoteDto[]) {
      return (ids: number[], directoryId: number) => {
         return _(directoryEditRestrictions)
            .filter(
               (res) =>
                  res.orgLevel === DirectoryEditRestrictionsState.ORGLEVEL_SUBSCRIBER &&
                  res.refType === FieldReferenceTypeEnum.GROUP.id &&
                  ids.includes(res.refId) &&
                  res.directoryId === directoryId
            )
            .value();
      };
   }

   @Action(DirectoryEditRestrictionsUpdated)
   public DirectoryEditRestrictionsUpdated(ctx: StateContext<DirectoryEditRestrictionsStateModel>, action: DirectoryEditRestrictionsUpdated) {
      ctx.patchState({
         directoryEditRestrictions: action.data.directoryEditRestriction?.directoryEditRestriction ?? [],
      });
   }
}
